import React, { useEffect } from "react";
import { VerticalTemplates } from "../../../../../services/Templates";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";
import InputWrapper from "../cta/InputWrapper";

export default function EditCtaTemplate() {
  const { formData, selectedTemplateKey, setSelectedTemplateKey } =
    useEditCtaContext();
  const [type, setType] = React.useState(null);
  useEffect(() => {
    if (selectedTemplateKey.includes("vertical")) {
      setType("vertical");
    } else if (selectedTemplateKey.includes("centered")) {
      setType("centered");
    } else if (selectedTemplateKey.includes("horizontal")) {
      setType("horizontal");
    }
  }, [selectedTemplateKey]);
  return (
    <>
      {type &&
        (type === "vertical" ||
          type === "centered" ||
          type === "horizontal") && (
          <div className="min-w-md min-h-full md:h-full">
            <div className="flex flex-col md:flex-row w-full min-h-full md:h-full">
              <div className="py-3 md:py-5 flex flex-col justify-center bg-white w-full md:w-1/2 flex-shrink-0">
                {(() => {
                  const PreviewComponent =
                    VerticalTemplates[selectedTemplateKey]?.preview;
                  return PreviewComponent ? (
                    <PreviewComponent {...formData} preview={true} />
                  ) : null;
                })()}
              </div>
              <div className="w-full md:w-1/3 flex-shrink-0">
                <InputWrapper />
              </div>
            </div>
          </div>
        )}
    </>
  );
}
